import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import {
  getProjectInterested,
  GetProjectInterestedAction
} from 'src/actions/project/interested/get/GetProjectInterested.actions';
import { RootState } from 'src/reducers/RootReducer';
import ProjectActionToolbarComponent, { ProjectActionToolbarComponentProps } from './ProjectActionToolbar.component';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import {
  createProjectInterested,
  CreateProjectInterestedAction
} from 'src/actions/project/interested/create/CreateProjectInterested.actions';
import { OpenModal, openModal } from 'src/actions/modal';
import InvestmentInformationContainer from 'src/modules/modals/investment-funnel/InvestmentInformation.container';
import LoginContainer from 'src/modules/modals/login/Login.container';
import RegisterContainer from 'src/modules/modals/register/Register.container';
import InvestorType from 'src/entities/InvestorType';
import {
  getInvestorType,
  GetInvestorTypeAction
} from 'src/actions/investor-type/get/GetInvestorType.actions';
import Project from 'src/entities/Project';
import Investment from 'src/entities/Investment';
import {
  indexInvestments,
  IndexInvestmentsAction,
  IndexInvestmentsSuccess
} from 'src/actions/investment/index/IndexInvestments.actions';
import * as Types from 'src/actions/investment/index/Types';
import AccreditationExpiredContainer from 'src/modules/modals/investment-funnel/AccreditationExpired.container';
import LimitReachedContainer from 'src/modules/modals/investment-funnel/limit-reached/LimitReached.container';
import InvestmentFormContainer from 'src/modules/modals/investment-funnel/InvestmentForm.container';
import Person from 'src/entities/Person';
import User from 'src/entities/User';
import * as moment from 'moment';
import RawAmountInvestmentComponent
  from 'src/modules/modals/investment-funnel/raw-amount-investment/RawAmountInvestment.component';

interface StateProps {
  activeProfile?: Person;
  loggedUserData: number | null;
  projectInterested?: Person[];
  loggedUser?: boolean;
  isLogged?: boolean;
  interestedUser?: boolean;
  investorType?: InvestorType;
  user: User | undefined;
}

interface DispatchProps {
  getUser(userId: number): Promise<GetUserAction>;

  getProjectInterested(projectId: number, personId: number, personType: string): void;

  createProjectInterested(projectId: number, person: Person): Promise<CreateProjectInterestedAction>;

  openModal(component: JSX.Element): void;

  getInvestorType(personId: number, personType: string): Promise<GetInvestorTypeAction>;

  indexInvestments(profileId: number, profileType: string, lastYear: boolean): Promise<IndexInvestmentsAction>;
}

interface Props extends StateProps, DispatchProps {
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

interface State {
  founder: boolean;
}

class ProjectActionToolbarContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      founder: false,
    };
  }

  public componentWillMount(): void {
    if (this.props.loggedUserData && !this.props.activeProfile) {
      this.props.getUser(this.props.loggedUserData).then((response) => {
        if (response.type === getUserTypes.GET_USER_SUCCESS) {
          this.checkFounder(this.props.activeProfile!);
          this.props.getInvestorType(this.props.activeProfile!.id, this.props.activeProfile!.personType);
          if (this.props.invest) {
            this.invest();
          }
        }
      });
    } else if (this.props.loggedUserData && this.props.activeProfile) {
      this.checkFounder(this.props.activeProfile);
      this.props.getInvestorType(this.props.activeProfile.id, this.props.activeProfile!.personType);
      if (this.props.invest) {
        this.invest();
      }
    }
  }

  public checkFounder(profile: Person) {
    if (((profile.personType === 'physical') && (this.props.project!.company.founderId !== profile.id)) ||
      (profile.personType === 'juridical')) {
      this.setState({ founder: false });
    } else {
      this.setState({ founder: true });
    }
  }

  public componentWillReceiveProps(newProps: Props) {
    if (this.props.activeProfile !== newProps.activeProfile) {
      this.checkFounder(newProps.activeProfile!);
    }
  }

  public render(): React.ReactNode {
    if (this.props.project.status !== 'En financiación') {
      return null;
    }

    return (
      <ProjectActionToolbarComponent {...this.getComponentProps()} />
    );
  }

  private interest(): void {
    this.props.createProjectInterested(this.props.project.id, this.props.activeProfile!).then(() => {
      this.props.getProjectInterested(
        this.props.project.id,
        this.props.activeProfile!.id,
        this.props.activeProfile!.personType
      );
    });
  }

  private invest(): void {

    this.props.indexInvestments(
      this.props.activeProfile!.id,
      this.props.activeProfile!.personType,
      true
    ).then((response) => {
      if (response.type !== Types.INDEX_INVESTMENT_SUCCESS) {
        return;
      }

      let reinvestment = 0;
      let investedTickets = 0;

      const amountInvestedLastYear = (response as IndexInvestmentsSuccess)
        .payload
        .reduce(
          (amount: number, investment: Investment) => {
            if (investment.project!.id === this.props.project.id) {
              reinvestment += investment.amountInvested;
              investedTickets += investment.quantityTickets;
            }
            return amount + investment.amountInvested;
          },
          0
        );

      let reachedType = 0;
      if (this.props.investorType!.type === 'No acreditado' &&
        amountInvestedLastYear + this.props.project.ticketValue > 10000) {
        reachedType = 1;
      }
      if (this.props.investorType!.type === 'No acreditado' &&
        reinvestment + this.props.project.ticketValue > 3000) {
        reachedType = 2;
      }

      if (reachedType) {
        this.props.openModal(
          <LimitReachedContainer
            amountInvestedLastYear={amountInvestedLastYear}
            reachedType={reachedType}
          />
        );
        return;
      } else if (reinvestment) {
        if (investedTickets === 0) {
          this.props.openModal(
            <RawAmountInvestmentComponent
              project={this.props.project}
            />
          );
          return;
        }
        this.props.openModal(
          <InvestmentFormContainer />
        );
        return;
      } else if (
        this.props.investorType!.type === 'Acreditado' &&
        this.props.investorType!.accreditationExpired
      ) {
        this.props.openModal(
          <AccreditationExpiredContainer />
        );
        return;
      }
      this.props.openModal(
        <InvestmentInformationContainer />
      );
    });
  }

  private login(): void {
    this.props.openModal(
      <LoginContainer />
    );
  }

  private register(): void {
    this.props.openModal(
      <RegisterContainer />
    );
  }

  private allowInvest(): boolean {
    return (
      !this.state.founder 
      && (
        moment.utc(this.props.project.endDate).isSameOrAfter(moment(moment()).subtract(1, 'days')) 
        && this.props.project.status === 'En financiación' 
        && this.getInvestedPercent() < 125
        && (this.props.project.ticketValue + this.props.project.cash) < (125 * this.props.project.cashTarget / 100)
      )
    );
  }

  private getInvestedPercent(): number {
    let invested;

    if (this.props.project.cashTarget === 0) {
      invested = 125;
    } else {
      invested = Math.round(this.props.project.cash / this.props.project.cashTarget * 100) <= 125 ?
        Math.round(this.props.project.cash / this.props.project.cashTarget * 100) : 125;
    }

    return invested;
  }

  private getComponentProps(): ProjectActionToolbarComponentProps {
    return {
      user: this.props.isLogged!,
      interested: this.state.founder ? !this.state.founder : !this.props.interestedUser!,
      allowInvest: this.allowInvest(),
      closedProject: this.props.closedProject,
      interest: () => this.interest(),
      invest: () => this.invest(),
      login: () => this.login(),
      register: () => this.register(),
    };
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
    getUser: (userId: number): Promise<GetUserAction> => (
      dispatch(getUser(userId))
    ),
    getProjectInterested: (
      projectId: number,
      personId: number,
      personType: string
    ): Promise<GetProjectInterestedAction> => (
        dispatch(getProjectInterested(projectId, personId, personType))
      ),
    createProjectInterested: (projectId: number, person: Person): Promise<CreateProjectInterestedAction> => (
      dispatch(createProjectInterested(projectId, person))
    ),
    openModal: (component: JSX.Element): OpenModal => (
      dispatch(openModal(component))
    ),
    getInvestorType: (personId: number, personType: string): Promise<GetInvestorTypeAction> => (
      dispatch(getInvestorType(personId, personType))
    ),
    indexInvestments: (
      profileId: number, profileType: string, lastYear: boolean
    ): Promise<IndexInvestmentsAction> => (
        dispatch(indexInvestments(profileId, profileType, lastYear))
      )
  });

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  activeProfile: state.getUser.activeProfile,
  loggedUserData: state.authentication.loggedUserData,
  isLogged: state.authentication.isLogged,
  projectInterested: state.getProjectInterested.projectInterested,
  interestedUser: state.getProjectInterested.interestedUser,
  investorType: state.getInvestorType.investorType,
  user: state.getUser.user
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectActionToolbarContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/action-toolbar/ProjectActionToolbar.container.tsx